module.exports = "/images/vendor/svg-country-flags/svg/es.svg?628f10fe057a86d47f75d765dce23dac";